import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useRouter } from 'next/router'
import { useState } from 'react'

import { useAuth } from '~/components/Auth/AuthProvider'
import { useGlobal } from '~/components/Common/GlobalDataProvider'
import { Spacer } from '~/components/Common/Spacer'
import Icon from '~/components/Icon'
import $posthog from '~/lib/posthog'
import { BusinessI } from '~/types'
import { setCurrentBusiness } from '~/utils'
import { PopupBusinessForm } from './PopupBusinessForm'
import { PopupJoinBusiness } from './PopupJoinBusiness'

dayjs.extend(utc)

interface BusinessAction {
    localeText: any
}

export const BusinessAction = ({ localeText }: BusinessAction) => {
    const router = useRouter()
    const { profile, loadProfile } = useAuth()

    const { setToastProps } = useGlobal()
    const [showBusinessForm, setShowBusinessForm] = useState(false)
    const [showJoinForm, setShowJoinForm] = useState(false)

    const onSaveBusiness = async (business: BusinessI) => {
        await loadProfile()
        setCurrentBusiness(Number(business.businessId))

        setToastProps({
            message: localeText?.business?.message?.saved,
            open: true,
            wrapper: 'right-hand-side'
        })

        window.location.href = '/business/product'
    }

    const createBusiness = () => {
        setShowBusinessForm(true)
        $posthog.capture('business_create_tap')
    }

    const joinBusiness = () => {
        setShowJoinForm(true)
        $posthog.capture('business_join_tap')
    }

    return (
        <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 mx-auto max-w-3xl">
                <div
                    className="flex items-center rounded-xl p-4 hover:bg-[#FFF1EB] transition-colors text-neutrals-900"
                    role="button"
                    onClick={createBusiness}>
                    <span className="p-2.5 bg-primary-100 rounded-lg text-primary mr-6 flex items-center justify-center">
                        <Icon name="store" width={36}></Icon>
                    </span>
                    <div className="mr-1">
                        <h3 className="font-bold mb-0.5 text-lg">
                            {localeText?.onboarding?.action?.add_business?.title}
                        </h3>
                        <p className="text-sm">{localeText?.onboarding?.action?.add_business?.description}</p>
                    </div>
                    <Spacer></Spacer>
                    <Icon name="chevron-right" width={30}></Icon>
                </div>
                <div
                    className="flex items-center border rounded-xl p-4 hover:bg-[#FFF1EB] transition-colors text-neutrals-900"
                    role="button"
                    onClick={joinBusiness}>
                    <span className="p-2.5 bg-green-100 rounded-lg text-green mr-6 flex items-center justify-center">
                        <Icon name="link" width={36}></Icon>
                    </span>
                    <div className="mr-1">
                        <h3 className="font-bold mb-0.5 text-lg">
                            {localeText?.onboarding?.action?.join_business?.title}
                        </h3>
                        <p className="text-sm">{localeText?.onboarding?.action?.join_business?.description}</p>
                    </div>
                    <Spacer></Spacer>
                    <Icon name="chevron-right" width={30}></Icon>
                </div>
            </div>

            <PopupBusinessForm
                show={showBusinessForm}
                localeText={localeText}
                onSave={(business) => onSaveBusiness(business)}
                onClose={() => setShowBusinessForm(false)}></PopupBusinessForm>
            <PopupJoinBusiness
                localeText={localeText}
                show={showJoinForm}
                onSave={() => router.push('/business')}
                onClose={() => setShowJoinForm(false)}></PopupJoinBusiness>
        </>
    )
}
